import React from "react";
import _ from "lodash";
import Select from "react-select";
import { useSelector } from "react-redux";

const THREE_ONE_ONE_OPTION = { key: "THREE_ONE_ONE", value: "311" };

export default function EncounterTypePicker({ value, onChange, disabled }) {
    const features = useSelector(state => state.user?.features);
    const has311Feature = features?.some(f => f.feature === '311_ENCOUNTERS') ?? false;

    // Base encounter types (always available)
    let encounterTypeOptions = [
        { key: "CAD", value: "CAD" },
        { key: "RMS_CASE", value: "Records - Case" }
    ];

    // Add 311 only if feature flag is enabled
    if (has311Feature) {
        encounterTypeOptions.push(THREE_ONE_ONE_OPTION);
    }

    const encounterTypeKeyLabels = { [THREE_ONE_ONE_OPTION.key]: THREE_ONE_ONE_OPTION.value };

    let selectedEncounterType = _.find(encounterTypeOptions, (o) => o.key === value);

    if (!selectedEncounterType && value) {
        selectedEncounterType = disabled
            ? { key: value, value: encounterTypeKeyLabels[value] || value }
            : encounterTypeOptions[0];
    }

    React.useEffect(() => {
        if (!disabled && value && !_.find(encounterTypeOptions, (o) => o.key === value)) {
            onChange({ key: encounterTypeOptions[0].key }, { action: 'select-option' });
        }
    }, [value, disabled]);

    return (
        <Select className="tableCell selectCell" classNamePrefix="selectCell"
            isDisabled={disabled}
            onChange={onChange}
            value={selectedEncounterType}
            options={encounterTypeOptions}
            getOptionLabel={option => option.value}
            getOptionValue={option => option.key}
        />
    )

}